import React, { Component } from 'react';
import IndexPage from './Components/Pages/Nav/IndexPage';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './Reducers/actions.js';
import { ThemeProvider } from '@material-ui/core/styles';
import FlagstoneTheme from './Config/flagstoneTheme';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router } from 'react-router-dom';

class App extends Component {

  render() {
    return (
      <ThemeProvider theme={FlagstoneTheme}>
          <Router basename={`${process.env.PUBLIC_URL}`} >
            <IndexPage {...this.props}></IndexPage>
          </Router>
        <ToastContainer />
      </ThemeProvider>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  nav: state.nav,
  workstation: state.workstation,
  qualityCheck: state.qualityCheck,
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(withTranslation(), connect(
  mapStateToProps,
  mapDispatchToProps
))(App);
